(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("claimedPromotionsController", claimedPromotionsController);

  claimedPromotionsController.$inject = [
    "claimedPromotionsPayload",
    "Promotions",
    "PromotionsApi",
    "$rootScope",
  ];

  function claimedPromotionsController(
    claimedPromotionsPayload,
    Promotions,
    PromotionsApi,
    $rootScope,
  ) {
    var vm = this;

    // properties
    vm.claimedPromotions = claimedPromotionsPayload;
    vm.filters = {
      user_id: $rootScope.thisUser.id,
      page: 1,
    };

    // methods
    vm.getClaimedPromotions = getClaimedPromotions;

    /**
     * Gets claimed promotions from the API
     * @return {[type]} [description]
     */
    function getClaimedPromotions() {
      PromotionsApi.get(
        vm.filters,
        function handleGetPromotionsResponse(response) {
          vm.promotions = response;
        },
        function handleGetPromotionsError() {},
      );
    }
  }
})(angular);
